import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
// import CloseIcon  from '@mui/icons-material/Close';
// import { DividerComponent } from "../miniComponents";
import ModalComponent from "./modalComponent";
import AreYouSureModal from "./areYouSureModal";
import CustomIcon from "../customIcon";
import walletServices from "../../services/walletServices";
import { convertToIndianFormat } from "../../utils/functions";
import { getWalletMetrics } from "../../pages/wallet/utils/walletMetrics";

const MIN_WALLET_BALANCE = 1000;

export default function PaymentMode({ open, handleClose = () => { }, onBankTransfer = () => { }, isUPIEnabled = false, onUPI = () => {}, onPaymentGateway = () => { }, onWalletPay = () => {}, walletPayAmount = 0, loading = false }) {

    const [paymentMode, setPaymentMode] = useState(3);
    const [walletBalance, setWalletBalance] = useState(0);
    const [walletConfirmOpen, setWalletConfirmOpen] = useState(false);
    const payAmount = Number(walletPayAmount) || 0;


    const checkSelected = (value) => {
        return paymentMode === value
    }

    const handleSelect = (value) => {
        setPaymentMode(value);
    }

    const handleSubmit = () => {
        if (loading) return;
        if (paymentMode === 2) {
            setWalletConfirmOpen(true);
            return;
        }
        // parents close this modal / move to the next step from these handlers
        if (paymentMode === 0) onPaymentGateway();
        else if (paymentMode === 1) onBankTransfer();
        else if (paymentMode === 3) onUPI();
    }

    const handleWalletConfirm = () => {
        if (loading) return;
        setWalletConfirmOpen(false);
        handleClose();
        onWalletPay?.(walletBalance);
    }

    const isPartialWalletPay = walletBalance > 0 && payAmount > 0 && walletBalance < payAmount;
    const remainingAmount = Math.max(0, payAmount - walletBalance);
    const walletDeductAmount = isPartialWalletPay ? walletBalance : payAmount;

    useEffect(() => {
        if (!open) {
            setWalletConfirmOpen(false);
            return;
        }
        if (payAmount > 0 && payAmount < 100000 && isUPIEnabled) setPaymentMode(3);
        else setPaymentMode(1);

        const fetchWalletBalance = async () => {
            const res = await walletServices.getWalletSummary();
            const metrics = getWalletMetrics(res);
            setWalletBalance(metrics.available);
        }
        fetchWalletBalance();
    }, [open]);

    const showWalletOption = Boolean(onWalletPay) && walletBalance > MIN_WALLET_BALANCE;
    return (
        <>
            <AreYouSureModal
                open={walletConfirmOpen}
                setOpen={setWalletConfirmOpen}
                handleYes={handleWalletConfirm}
                message={
                    isPartialWalletPay ? (
                        <>
                            Are you sure you want to use {convertToIndianFormat(walletDeductAmount)} from your wallet towards this payment of {convertToIndianFormat(payAmount)}?
                        </>
                    ) : (
                        <>
                            Are you sure you want to pay {convertToIndianFormat(walletDeductAmount)} from your wallet?
                        </>
                    )
                }
                note={
                    isPartialWalletPay
                        ? `Your available wallet balance of ₹ ${convertToIndianFormat(walletBalance, false)} will be deducted. This transaction will be partially paid and you will need to pay the remaining ₹ ${convertToIndianFormat(remainingAmount, false)} through another payment method.`
                        : "This amount will be deducted from your available wallet balance."
                }
            />
            <ModalComponent open={open} handleClose={handleClose} title={"Select Payment Method"}>
                <Stack mt={4} spacing={2.5}>
                    {/* {walletPayAmount < 80000 && <Stack onClick={() => handleSelect(0)} direction={"row"} spacing={3} padding={2} sx={{ cursor: "pointer" }}>
                        <Box sx={{
                            minWidth: { xs: 24, md: 24 }, height: { xs: 24, md: 24 }, bgcolor: checkSelected(0) ? "success.main" : "success.light", borderRadius: "100%", display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }} >
                            {
                                checkSelected(0) ?
                                    <CustomIcon name="check" sx={{ bgcolor: "#FFF", width: { xs: 12, md: 12 }, height: { xs: 12, md: 12 }, }} />
                                    : ""
                            }
                        </Box>
                        <Stack spacing={0.5}>
                            <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                <Typography variant="body3" sx={{ lineHeight: 1 }}>Payment Gateway</Typography>
                            </Stack>
                            <Typography variant="subtitle1">Instant. Best option for transactions below Rs. 80,000.</Typography>
                        </Stack>
                    </Stack>} */}
                    {(walletPayAmount < 100000 && isUPIEnabled) && <Stack onClick={() => handleSelect(3)} direction={"row"} spacing={3} padding={2} sx={{ cursor: "pointer" }}>
                        <Box sx={{
                            minWidth: { xs: 24, md: 24 }, height: { xs: 24, md: 24 }, bgcolor: checkSelected(3) ? "success.main" : "success.light", borderRadius: "100%", display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }} >
                            {
                                checkSelected(3) ?
                                    <CustomIcon name="check" sx={{ bgcolor: "#FFF", width: { xs: 12, md: 12 }, height: { xs: 12, md: 12 }, }} />
                                    : ""
                            }
                        </Box>
                        <Stack spacing={0.5}>
                            <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                <Typography variant="body3" sx={{ lineHeight: 1 }}>UPI</Typography>
                            </Stack>
                            <Typography variant="subtitle1">Best option for transactions below Rs. 1,00,000.</Typography>
                        </Stack>
                    </Stack>}
                    <Stack onClick={() => handleSelect(1)} direction={"row"} spacing={3} padding={2} sx={{ cursor: "pointer" }}>
                        <Box sx={{
                            minWidth: { xs: 24, md: 24 }, height: { xs: 24, md: 24 }, bgcolor: checkSelected(1) ? "success.main" : "success.light", borderRadius: "100%", display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }} >
                            {
                                checkSelected(1) ?
                                    <CustomIcon name="check" sx={{ bgcolor: "#FFF", width: { xs: 12, md: 12 }, height: { xs: 12, md: 12 }, }} />
                                    : ""
                            }
                        </Box>
                        <Stack spacing={0.5}>
                            <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                <Typography variant="body3" sx={{ lineHeight: 1 }}>Bank Transfer</Typography>
                                {/* <CustomIcon name="info" sx={{bgcolor:"text.disabled",width:{xs:12,md:12},height:{xs:12,md:12},}} /> */}
                            </Stack>
                            <Typography variant="subtitle1">Recommended for options above Rs. 100,000.</Typography>
                        </Stack>
                    </Stack>
                    {showWalletOption && (
                        <Stack onClick={() => handleSelect(2)} direction={"row"} spacing={3} padding={2} sx={{ cursor: "pointer" }}>
                            <Box sx={{
                                minWidth: { xs: 24, md: 24 }, height: { xs: 24, md: 24 }, bgcolor: checkSelected(2) ? "success.main" : "success.light", borderRadius: "100%", display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }} >
                                {
                                    checkSelected(2) ?
                                        <CustomIcon name="check" sx={{ bgcolor: "#FFF", width: { xs: 12, md: 12 }, height: { xs: 12, md: 12 }, }} />
                                        : ""
                                }
                            </Box>
                            <Stack spacing={0.5}>
                                <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                    <Typography variant="body3" sx={{ lineHeight: 1 }}>Wallet</Typography>
                                </Stack>
                                <Typography variant="subtitle1">Pay from your RealX wallet balance.</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Available: {convertToIndianFormat(walletBalance)}
                                </Typography>
                                {walletBalance < payAmount && payAmount > 0 && (
                                    <Typography variant="caption" color="warning.dark" sx={{ display: "block" }}>
                                        Partial payment: {convertToIndianFormat(walletBalance)} from wallet, {convertToIndianFormat(remainingAmount)} remaining
                                    </Typography>
                                )}
                            </Stack>
                        </Stack>
                    )}
                    <Box sx={{ mt: 1, px: { xs: 8, md: 10 } }}>
                        <Button onClick={() => {
                            handleSubmit(paymentMode)
                        }} fullWidth variant="contained" disabled={loading}>Proceed to payment</Button>
                    </Box>
                </Stack>
            </ModalComponent>
        </>
        // <Dialog
        // scroll={"body"}
        // PaperProps={{sx:{overflow:"auto",maxWidth:470}}}
        // open={open}
        // onClose={handleClose}
        //     >
        //         <Card>
        //             <CardContent sx={{paddingTop:{md:"20px"}}}>
        //                 <Stack direction={"row"} justifyContent={"space-between"}>
        //                     <Typography variant="body3" sx={{fontWeight:500}}>Choose payment mode</Typography>
        //                     <CloseIcon onClick={handleClose} sx={{width:24,height:24,color:"text.disabled",cursor:"pointer"}} />
        //                 </Stack>
        //                 <Stack mt={1} spacing={2}>
        //                     <Box>
        //                         <DividerComponent />
        //                     </Box>
        //                     <Typography variant="body1" sx={{fontWeight:500}}>
        //                         Please select the convenient payment mode for completing the transaction.
        //                     </Typography>
        //                     <Box>
        //                         <DividerComponent />
        //                     </Box>
        //                     <Stack spacing={3} direction={"row"}>
        //                         <Button onClick={onPaymentGateway} fullWidth variant="contained">Payment Gateway</Button>
        //                         <Button onClick={onBankTransfer} fullWidth variant="outlined">Bank Transfer</Button>
        //                     </Stack>
        //                 </Stack>
        //             </CardContent>
        //         </Card>
        // </Dialog>
    )
}